import { InformationCircleIcon, ShieldKeyIcon, UserCheck01Icon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import moment from 'moment';

import { AnimatedModal } from 'components/AnimatedModal/AnimatedModal';
import { Button } from 'components/FormComponents';

const CAN_ACCESS = [
  'View all account data and settings',
  'Modify configurations to resolve issues',
  'Access audit logs and activity history',
  'Impersonate user sessions for troubleshooting',
];

export const GrantAccessModal = ({
  visible,
  request,
  onClose,
  onGrant,
  onDeny,
  granting = false,
  denying = false,
}) => {
  if (!request) return null;

  return (
    <AnimatedModal
      visible={visible}
      onClose={onClose}
      icon={UserCheck01Icon}
      oldIconLibrary={false}
      title="Grant Access"
      small>
      <div className="flex gap-6 u-margin-bottom">
        <div>
          <p className="t-small u-font-weight-600 secondary-text">Requested</p>
          <p className="t-small">{moment(request.created_at).format('MMM D, h:mma')}</p>
        </div>
        <div>
          <p className="t-small u-font-weight-600 secondary-text">Access Level</p>
          <p className="t-small">Administrator</p>
        </div>
      </div>

      {request.reason && (
        <div className="u-margin-bottom">
          <p className="t-small u-font-weight-600 secondary-text">Reason</p>
          <p className="t-small">{request.reason}</p>
        </div>
      )}

      <div className="flex items-start gap-2 bg-blue-50 border border-blue-200 rounded-lg p-3 u-margin-bottom">
        <HugeiconsIcon
          icon={InformationCircleIcon}
          size={18}
          strokeWidth={1.5}
          className="text-blue-600 flex-shrink-0 mt-0.5"
        />
        <p className="t-small text-blue-700">
          All support activity is logged for security and audit purposes
        </p>
      </div>

      <div className="u-margin-bottom">
        <p className="t-body u-font-weight-600 u-margin-bottom--small">What support can access</p>
        <ul className="flex flex-col gap-1 pl-5" style={{ listStyleType: 'disc' }}>
          {CAN_ACCESS.map(item => (
            <li key={item} className="t-small">
              {item}
            </li>
          ))}
        </ul>
      </div>

      <div className="flex justify-end gap-2">
        <Button type="secondary" onClick={onDeny} loading={denying}>
          Deny Access
        </Button>
        <Button type="primary" onClick={onGrant} loading={granting}>
          <span className="inline-flex items-center gap-1.5 text-white">
            <HugeiconsIcon icon={ShieldKeyIcon} size={20} strokeWidth={1.5} color="currentColor" />
            Grant Support Access
          </span>
        </Button>
      </div>
    </AnimatedModal>
  );
};
